/**
 * 解析管理端 API 根路径。
 * - 开发：使用相对路径 /api，由 vue.config.js devServer 代理到线上
 * - 打包部署：使用浏览器地址栏 origin + /api（同域访问后端）
 */
export function resolveApiBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }
  if (typeof window === 'undefined' || !window.location) {
    return '/api';
  }
  const { origin } = window.location;
  if (!origin || origin === 'null') {
    return '/api';
  }
  return `${origin.replace(/\/$/, '')}/api`;
}
